import * as Yup from 'yup'

const CompanyManagerDetailFormValidations = () => {
    return Yup.object().shape({
    })
}

export { CompanyManagerDetailFormValidations }